import classNames from "classnames";
import { useEffect, useState } from "react";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import EnterpriseService from "../../common/services/enterprise-service";
import moment from "moment";
import SingleCompanyAward from "./SingleCompanyAward";
import truckyService from "../../common/services/trucky-service";

const CompanyStats = ({ company, stats, container }) => {
  const es = new EnterpriseService();
  const [milesStats, setMilesStats] = useState(null);
  const [awards, setAwards] = useState([]);

  useEffect(() => {
    getMilesStats();
    getAwards();
  }, []);

  const getMilesStats = async () => {
    const result = await es.getCompanyStatsMonthly(
      company.id,
      moment().month() + 1,
      moment().year()
    );
    setMilesStats(result);
  };

  const getAwards = async () => {
    const result = await es.getCompanyAwards(company);
    setAwards(result);
  };

  return (
    <>
      <Card>
        <CardBody>
          <div className="stat-widgets">
            <div className="stat-widget stat-widget-info">
              <div className="stat-widget-icon">
                <FontAwesomeIcon icon="users" className="mx-0"></FontAwesomeIcon>
              </div>
              <div className="stat-widget-body">
                <div className="fw-bolder counted">{stats.members}</div>
                <div className="stat-widget-label">
                  {container.localeManager.strings.members}
                </div>
              </div>
            </div>
            <div className="stat-widget stat-widget-info">
              <div className="stat-widget-icon">
                <FontAwesomeIcon
                  icon="warehouse"
                  className="mx-0"
                ></FontAwesomeIcon>
              </div>
              <div className="stat-widget-body">
                <div className="fw-bolder counted">{stats.garages}</div>
                <div className="stat-widget-label">
                  {container.localeManager.strings.garages}
                </div>
              </div>
            </div>
            <div className="stat-widget stat-widget-success">
              <div className="stat-widget-icon">
                <FontAwesomeIcon
                  icon="truck"
                  className="mx-0"
                ></FontAwesomeIcon>
              </div>
              <div className="stat-widget-body">
                <div className="fw-bolder counted">{stats.vehicles}</div>
                <div className="stat-widget-label">
                  {container.localeManager.strings.vehicles}
                </div>
              </div>
            </div>
            <div
              className={classNames("stat-widget", {
                "stat-widget-danger": stats.balance < 0,
                "stat-widget-success": stats.balance >= 0,
              })}
            >
              <div className="stat-widget-icon">
                <FontAwesomeIcon
                  icon="wallet"
                  className="mx-0"
                ></FontAwesomeIcon>
              </div>
              <div className="stat-widget-body">
                <div className="fw-bolder counted">
                  {container.localeManager
                    .numeral(stats.balance)
                    .format("0,0")}{" "}
                  {company.currency}
                </div>
                <div className="stat-widget-label">
                  {container.localeManager.strings.balance}
                </div>
              </div>
            </div>
            <div className="stat-widget stat-widget-success">
              <div className="stat-widget-icon">
                <FontAwesomeIcon
                  icon="chart-line"
                  className="mx-0"
                ></FontAwesomeIcon>
              </div>
              <div className="stat-widget-body">
                <div className="fw-bolder counted">
                  {container.localeManager
                    .numeral(stats.revenues)
                    .format("0,0")}{" "}
                  {company.currency}
                </div>
                <div className="stat-widget-label">
                  {container.localeManager.strings.revenue}
                </div>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
      {awards.length > 0 && (
        <Card>
          <CardHeader>
            {container.localeManager.strings.companyAwards}
          </CardHeader>
          <CardBody>
            {awards.map((m) => (
              <div class="mb-1">
                <SingleCompanyAward
                  container={container}
                  award={m}
                ></SingleCompanyAward>
              </div>
            ))}
          </CardBody>
        </Card>
      )}
    </>
  );
};

export default CompanyStats;
